import { isResponse } from 'core/api/openApi.typesGuards';

export function consoleInfo(data: string | string[]) {
  if (import.meta.env.VITE_CONSOLE_LOG === 'ON') {
    console.info(typeof data === 'string' ? data : data.join('\n'));
  }
}
export function consoleInfoObjects(data: object | object[]) {
  if (import.meta.env.VITE_CONSOLE_LOG === 'ON') {
    if (Array.isArray(data)) {
      console.info(...data);
    } else {
      console.info(data);
    }
  }
}

export function consoleWarn(data: string | string[]) {
  if (import.meta.env.VITE_CONSOLE_LOG === 'ON') {
    console.warn(typeof data === 'string' ? data : data.join('\n'));
  }
}

export function consoleWarnResponse(text: string, url: string, response?: unknown) {
  const data = [
    text,
    `URL: ${url}`,
  ];

  if (isResponse(response)) {
    data.push(`Status: ${response.status || 'Missing'}`);
    data.push(`Status text: ${response.statusText || 'Missing'}`);
    data.push(`Body: ${JSON.stringify(response.body)}`);
  } else {
    data.push('Missing response');
  }

  consoleWarn(data);
}
